export const isPikselLogin = (vlHash) => vlHash.substring(0, 3) === 'PX-';
